module.exports = __webpack_public_path__ + "fonts/inter-v11-latin-200.109a0e1.eot";